import { useEffect, useMemo } from 'react';
import { prizeRewards } from '../../../../../utils/prizes/prizes';
import { levelModalContent } from '../../../../../constants/copyright-modals';
import { useAppState, useContent } from '../../../../../redux/reducer/content';
import { useLevelData } from '../../../../../hooks/useLevelData';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { MAIN } from '../../../../../constants/shared/states/names';
import { useService } from '../../../../../redux/reducer/service';
import { isNumber } from 'lodash';
import useServiceData from '../../../../../hooks/useServiceData';

export default function useHandleLevelRewards() {
  const { showLevelPrizes } = useContent();
  const { serviceData } = useService();
  const { levels } = useLevelData();
  const { level } = useLevelData();
  const { save } = useServiceData();

  const callbacks = useApplicationCallbacks();

  useEffect(() => {
    // Так как раньше не вываливались модальники с призами за уровни, чтобы новым пользователям не насыпало ими,
    // модальники будут показываться только при достижении поcледующих уровней, для этого нужен флаг
    // для определения текущего уровня
    if (!serviceData || !isNumber(level) || isNumber(serviceData.extraData?.levelRewardsBorder)) return;

    const { extraData = {} } = serviceData;

    if (!isNumber(extraData.levelRewardsBorder)) save('extraData', { ...extraData, levelRewardsBorder: level });
  }, [level, serviceData]);

  return useMemo(() => {
    if (!showLevelPrizes?.length || !levels || !serviceData || !isNumber(serviceData.extraData?.levelRewardsBorder))
      return [];

    const {
      extraData: { levelRewardsBorder },
    } = serviceData;

    return showLevelPrizes.reduce((acc, prize) => {
      const { id, required_score, image } = prize;
      const lvl = levels.find((level) => level.required_score === required_score)?.number;

      if (lvl <= levelRewardsBorder) return acc;

      const rewards = prizeRewards(prize);
      const icons = rewards.reduce((acc, { type }) => ({ ...acc, [type]: image }), {});
      acc.push({
        id: `passedLevelModal${required_score}`,
        type: 'wModal',
        props: {
          type: 'level',
          lvl,
          rewards,
          extraIcons: icons,
          prize,
          ...levelModalContent,
          onCloseCallbacks: {
            level: () => callbacks.setShowLevelPrizes({ prizeData: { id }, action: 'removeOne' }),
          },
        },
      });

      return acc;
    }, []);
  }, [showLevelPrizes, serviceData, levels]);
}
